/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".stage-btn[_ngcontent-%COMP%]{font-size:2rem;color:#fff}"];
export { styles as styles };
